let mobileMenuLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback()

    if (mobileMenuLoaded) return

    window.BAO.sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=mobile-menu`,
      )
      .then((res) => {
        mobileMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )
        const myself = newDOM.querySelector('mobile-menu')

        if (!myself) return

        console.log('[ABTEST MobileMenu] drawer markup re-injected from /?view=mobile-menu — replacing mobile-menu element')

        this.outerHTML = myself.outerHTML
      })
      .catch(() => { })
  }

  setupListeners() {
    super.setupListeners()

    if (!this.els.trigger?.exists) return

    this.handleDrawerChange = this.handleDrawerChange.bind(this)

    document.addEventListener('drawer-changed', this.handleDrawerChange)

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleBack = this.handleBack.bind(this)
    this.trapFocus = this.trapFocus.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
    this.listeners.add(this, 'click', this.handleBack)
    this.listeners.add(document, 'keydown', this.trapFocus)
  }

  trapFocus(event) {
    if (event.key !== 'Tab') return
    if (!this.contains(document.activeElement)) return

    const focusableEls = Array.from(
      this.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((el) => !el.closest('[hidden]') && el.offsetParent !== null)

    if (!focusableEls.length) return

    const firstEl = focusableEls[0]
    const lastEl = focusableEls[focusableEls.length - 1]

    if (event.shiftKey) {
      if (document.activeElement === firstEl) {
        event.preventDefault()
        lastEl.focus()
      }
    } else {
      if (document.activeElement === lastEl) {
        event.preventDefault()
        firstEl.focus()
      }
    }
  }

  handleTrigger(event) {
    const clickedTrigger = event.target.closest(this.els.trigger.selector)

    if (!clickedTrigger) return

    // Trigger and submenu must belong to the same menu, so that AB test
    // variants with shared link titles don't open the control submenu
    const menuGroup = clickedTrigger.closest('[data-mobile-menu]')

    const matchedSubMenu = this.els.submenu.elements.find(
      (submenuEl) =>
        submenuEl.dataset.handle === clickedTrigger.dataset.handle &&
        submenuEl.dataset.level === clickedTrigger.dataset.level &&
        submenuEl.dataset.topNavHandle === clickedTrigger.dataset.topNavHandle &&
        (!menuGroup || submenuEl.closest('[data-mobile-menu]') === menuGroup),
    )

    if (!matchedSubMenu) return

    matchedSubMenu.classList.add('drw-Drawer-active')
    document.querySelector('.section-header').classList.add('menu-open');
    matchedSubMenu.show()
  }

  handleBack(event) {
    const backButtonEl = event.target.closest(this.els.back.selector)

    if (!backButtonEl) return

    const submenuEl = event.target.closest(this.els.submenu.selector)

    if (!submenuEl) return

    submenuEl.classList.remove('drw-Drawer-active')
    submenuEl.close()
  }

  handleDrawerChange() {
    this.els.submenu.elements.forEach((submenuEl) => {
      submenuEl.classList.remove('drw-Drawer-active')
      document.querySelector('.section-header').classList.remove('menu-open');
      submenuEl.close()
    })
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
